import React from 'react';
import { InputList } from 'framework/form';
import VendorsContactInputs from './VendorsContactInputs';

const VendorContactsListInput = () => {
  return (
    <InputList
      defaultValue={{
        name: '',
        phoneNumber: '',
        email: '',
      }}
      rowSx={{
        display: 'flex',
        flexWrap: 'wrap',
        marginBottom: '15px !important',
        '& .form-group': {
          marginBottom: '10px',
        },
        '&& .add-info-btn.input-list-rm-btn': {
          margin: 0,
          width: '100%',
        },
      }}
      maxFields={3}
      inputTemplate={VendorsContactInputs}
      source="contacts"
    />
  );
};

export default VendorContactsListInput;
